import * as Actions from './actions/actions';
//@ts-ignore
import watch from 'redux-watch';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';

export default class SessionGenerator {
	_settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
	_initialize: any;
	_initializeCompleted: any;
	_setStates: any

	constructor(settings: AlightCustomSettingsType, initialize: any) {
		this._settings = settings;
		this._initialize = initialize;
	}

	initialize(store: Store<AlmeState>) {
		this._store = store;
		this._initializeCompleted = false;

		this._setStates = this._settings.generateNewSession.stateSets;

		let watchState = this._settings.stateLocations.GenerateNewSession.Base + '.' + this._settings.stateLocations.GenerateNewSession.generateNewSessionFlag;

		let watcher = watch(this._store.getState, watchState);

		this._store.subscribe(watcher((newVal: any, oldVal: any, objectPath: any) => {
			if(newVal === 'process') return this.handleGenerateNewSession();
		}));
	}

	handleGenerateNewSession() {
		let setLen = this._setStates.length;

		for(let i = 0; i < setLen; i++) {
			let cur = this._setStates[i];

			this._store?.dispatch(Actions.setStateForNewSession(cur));
		}

		if(this._initializeCompleted){
			this._initializeCompleted = false;
			this._initialize.startApplicationInitialize()
		}

		console.log("NIT: Restart complete")
	}
}


// WEBPACK FOOTER //
// ./modules/generate-new-session/session-generator.ts